import { useMatch } from "react-router-dom";
import { listAndDetailSamplesRoutes, listAndDetailSamplesRoutesCombined } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSampleEditForm } from "../ListAndDetailSampleEditForm";

export const ListAndDetailSamplesAdditionalActionsEditPage = () => {

    const match = useMatch(listAndDetailSamplesRoutesCombined.additionalActions_editMatch);
    const cityTownCode = match?.params.cityTownCode;

    return (
        <ListAndDetailSampleEditForm
            listUrl={listAndDetailSamplesRoutes.additionalActions}
            cityTownCode={cityTownCode}
        />
    )
}
